import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { Tooltip } from "components/Tooltips/Tooltip";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import { useMessage } from "hooks/intl";
import { TooltipData } from "./types";

const renderTooltipData = ({
  tooltipData,
  classes,
}: {
  tooltipData?: TooltipData;
  classes: any;
}) => {
  if (!tooltipData || !tooltipData?.data) return "";
  switch (tooltipData.type) {
    case "key":
      return (
        <>
          {tooltipData.data.map((label) => (
            <div key={label.key} className={classes.element}>
              {label.key}
            </div>
          ))}
        </>
      );
    case "keyValue":
      return (
        <>
          {tooltipData.data.map((data, index) => (
            <div key={index} className={classes.element}>
              {data.key}:{data.value}
            </div>
          ))}
        </>
      );
    case "labels":
      return (
        <>
          {tooltipData.data.map((label) => (
            <div key={label} className={classes.element}>
              {label}
            </div>
          ))}
        </>
      );
    default:
      return "";
  }
};

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    moreElements: {
      fontSize: "14px",
      color: theme.primary500,
      cursor: "pointer",
    },
    element: {
      margin: theme.spacing(3),
      fontSize: 12,
      color: theme.gray500,
    },
  }),
);

export function MoreElements({
  totalItemsNumber,
  maxVisibleElementsCount = 3,
  tooltipData,
}: {
  totalItemsNumber: number;
  maxVisibleElementsCount?: number;
  tooltipData?: TooltipData;
}) {
  const classes = useStyles();
  const { message } = useMessage();

  return (
    <>
      {totalItemsNumber > maxVisibleElementsCount && (
        <Tooltip text={renderTooltipData({ tooltipData, classes })}>
          <span className={classes.moreElements}>
            {message(
              { id: "moreElements" },
              { count: totalItemsNumber - maxVisibleElementsCount },
            )}
          </span>
        </Tooltip>
      )}
    </>
  );
}
